import { render, staticRenderFns } from "./common-grid-box.vue?vue&type=template&id=db9753ac"
import script from "./common-grid-box.vue?vue&type=script&lang=js"
export * from "./common-grid-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports